export default "__VITE_ASSET__98QNIfKh__"